function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg151Kosovo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "145.944,179.757 150.181,192.796 163.888,192.796 152.799,200.852 157.035,213.889    145.944,205.832 134.853,213.889 139.09,200.852 128,192.796 141.707,192.796  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "188.611,166.957 192.848,179.996 206.555,179.996 195.465,188.052 199.701,201.089    188.611,193.032 177.52,201.089 181.757,188.052 170.666,179.996 184.375,179.996  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "231.277,154.157 235.514,167.196 249.222,167.196 238.131,175.252 242.369,188.289    231.277,180.232 220.187,188.289 224.423,175.252 213.334,167.196 227.041,167.196  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "366.055,179.757 361.819,192.796 348.112,192.796 359.201,200.852 354.965,213.889    366.055,205.832 377.147,213.889 372.91,200.852 384,192.796 370.293,192.796  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "323.389,166.957 319.152,179.996 305.445,179.996 316.535,188.052 312.299,201.089    323.389,193.032 334.48,201.089 330.243,188.052 341.334,179.996 327.625,179.996  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "280.723,154.157 276.486,167.196 262.778,167.196 273.869,175.252 269.631,188.289    280.723,180.232 291.813,188.289 287.577,175.252 298.666,167.196 284.959,167.196  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M290.134,265.089L256,222.422l-17.066,8.534v17.066l-25.6,17.066h-17.066v22.048  c25.015,10.129,42.666,34.638,42.666,63.285l0,0H256v-17.066l17.066-17.066l17.066,17.066l17.067-17.066v-17.066l17.066-25.6  L290.134,265.089z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg151Kosovo);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };